import { DormitoryServicePath, ROOM_TYPES, SUBSIDIES } from "utils/constants";
import permissions from "app/permissions";
import CreateStateSubsidy from "./Create";

export const resources = {
  name: `${DormitoryServicePath}${ROOM_TYPES}/:typeId/${SUBSIDIES}/create`,
  title: "Създаване на държавна субсидия",
  custom: <CreateStateSubsidy />,
  permission: permissions.canManageDormitoryStateSubsidies,
};
